import { Box, Stack, Typography } from "@mui/material";
import { Ticket } from "../../../services/swagger";
import { useTranslation } from "react-i18next";
import FieldLabel from "../../atoms/FieldLabel";
import HandymanIcon from "@mui/icons-material/Handyman";

interface TicketServiceCall {
  ticket: Ticket;
}

export default function TicketServiceCall(props: TicketServiceCall) {
  const { t } = useTranslation("Ticket");
  const { ticket } = props;
  if (!ticket.service_call) return null;
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: (theme) => (theme.shape.borderRadius as number) / 8,
      }}
    >
      <Stack spacing={1}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <HandymanIcon fontSize="small" color="primary" />
            <FieldLabel>
              {t("ServiceCall")}{" "}
              {ticket.service_call?.call_id
                ? `#${ticket.service_call.call_id}`
                : ""}
            </FieldLabel>
          </Stack>
        </Box>
        {!ticket.service_call && (
          <Typography fontSize={"small"} color="text.secondary">
            {t("NoServiceCall")}
          </Typography>
        )}
      </Stack>
    </Box>
  );
}
